<template>
  <li v-click-outside="blur" :class="[{open:show,disabled:disabled}]">
    <a role="button" :class="['dropdown-toggle']"
      @keyup.esc="show = false"
      @click.prevent="toggle"
    >
      <slot name="button-content"></slot>
    </a>
    <slot name="dropdown-menu">
    </slot>
  </li>
</template>
<script>
import $ from 'utils/NodeList.js'
import ClickOutside from 'utils/directives/ClickOutside.js'

export default {
  directives: {
    ClickOutside
  },
  props: {
    disabled: {type: Boolean, default: false},
    value: {type: Boolean, default: false}
  },
  data () {
    var show = this.value
    return {show}
  },
  watch: {
    show (val) { this.$emit('input', val) },
    value (val) { this.show = val }
  },
  methods: {
    blur () { this.show = false },
    toggle () {
      this.show = !this.show
    }
  },
  mounted () {
    $('ul', this.$el).on('click', 'li>a', e => { this.show = false })
  },
  beforeDestroy () {
    $('ul', this.$el).off()
  }
}
</script>



// WEBPACK FOOTER //
// Dropdown.vue?60118db6